module.exports = __webpack_public_path__ + "static/media/albumCd_default.5cd6fc21.png";